import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=06bb4c3c&"
import script from "./RouterButton.vue?vue&type=script&lang=js&"
export * from "./RouterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports